import { atom, selector } from 'recoil';

export const reasonForLateReasonIsOtherState = atom<boolean>({
  key: 'responseLateReasonIsOther',
  default: false,
});

export const reasonForLateResponseIdState = atom<number | undefined>({
  key: 'reasonForLateResponseId',
  default: undefined,
});

export const reasonForLateResponseDetailState = atom<string | undefined>({
  key: 'reasonForLateResponseDetail',
  default: undefined,
});

export const reasonForLateResponseState = selector({
  key: 'reasonForLateResponseState',
  get: ({ get }) => {
    return {
      reasonForLateReasonIsOther: get(reasonForLateReasonIsOtherState),
      reasonForLateResponseId: get(reasonForLateResponseIdState),
      reasonForLateResponseDetail: get(reasonForLateResponseDetailState),
    };
  },
});
